import { Inject, InjectionToken, ModuleWithProviders, NgModule, Optional, SkipSelf, inject, provideAppInitializer } from '@angular/core';

import { ConfigLoader, ConfigStaticLoader } from './config.loader';
import { ConfigPipe } from './config.pipe';
import { ConfigService } from './config.service';

export const configFactory = () => new ConfigStaticLoader();

export const initializerFactory = (config: ConfigService) => {
  // workaround for AoT compilation
  const res = () => config.init();

  return res;
};

export const CONFIG_FORROOT_GUARD = new InjectionToken('CONFIG_FORROOT_GUARD');

// tslint:disable-next-line:only-arrow-functions
// eslint-disable-next-line
export function provideForRootGuard(config?: ConfigService): any {
  if (config) {
    throw new Error(`ConfigModule.forRoot() called twice. Lazy loaded modules should use ConfigModule.forChild() instead.`);
  }

  return 'guarded';
}

@NgModule({
  declarations: [ConfigPipe],
  exports: [ConfigPipe],
})
export class ConfigModule {
  public static forRoot(
    // eslint-disable-next-line
    configuredProvider: any = {
      provide: ConfigLoader,
      useFactory: configFactory,
    },
  ): ModuleWithProviders<ConfigModule> {
    return {
      ngModule: ConfigModule,
      providers: [
        configuredProvider,
        ConfigService,
        provideAppInitializer(() => {
          const initializerFn = initializerFactory(inject(ConfigService));
          return initializerFn();
        }),
        {
          provide: CONFIG_FORROOT_GUARD,
          useFactory: provideForRootGuard,
          deps: [[ConfigService, new Optional(), new SkipSelf()]],
        },
      ],
    };
  }

  public static forChild(): ModuleWithProviders<ConfigModule> {
    return {
      ngModule: ConfigModule,
    };
  }

  // tslint:disable-next-line:no-empty
  // eslint-disable-next-line
  constructor(@Optional() @Inject(CONFIG_FORROOT_GUARD) guard: any) {}
}
